function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent.vue';
import WorkEnvironmentsService from '@/services/work_env_service';
import FormResourceRequestComponent from '@/apps/analytic-services/components/FormResourceRequestComponent';
import FormRequestUpdateComponent from '@/apps/analytic-services/components/FormRequestUpdateComponent';
import LineChart from '@/components/LineChart';
import utils from '@/utils/firebase';
import { mapMutations } from 'vuex';
var firebaseDataOperation = utils.getFirebaseDataOperation();
export default {
  name: 'MyResourcesPage',
  components: {
    FormRequestUpdateComponent: FormRequestUpdateComponent,
    LineChart: LineChart,
    FormResourceRequestComponent: FormResourceRequestComponent,
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    return {
      MODAL_REQUEST_RESOURCE: 'MODAL_REQUEST_RESOURCE',
      MODAL_REQUEST_UPDATE: 'MODAL_REQUEST_UPDATE',
      MODAL_MONITORING_RESOURCE: 'MODAL_MONITORING_RESOURCE',
      isBusy: false,
      fields: [{
        key: 'instance_name',
        label: 'Notebook'
      }, {
        key: 'pr_name',
        label: 'Project GCP'
      }, {
        key: 'notebook_url',
        label: 'Link'
      }, {
        key: 'status',
        label: 'Status',
        class: 'text-center'
      }, {
        key: 'actions',
        class: 'text-center'
      }],
      items: [],
      item: {},
      itemToUpdate: {},
      config: {},
      loaded: false,
      cpuData: {
        labels: [],
        datasets: [{
          backgroundColor: '#483D8B',
          borderColor: '#483D8B',
          borderWidth: 2,
          data: [],
          fill: false,
          label: 'Cpu Use',
          lineTension: 0,
          pointBorderColor: '#000000',
          pointBorderWidth: 1,
          pointRadius: 2
        }, {
          backgroundColor: '#00BFFF',
          borderColor: '#00BFFF',
          borderWidth: 2,
          data: [],
          fill: false,
          label: 'Ram Use',
          lineTension: 0,
          pointBorderColor: '#000000',
          pointBorderWidth: 1,
          pointRadius: 2
        }]
      },
      key_table: 1
    };
  },
  created: function created() {
    this.getInitialConfig();
    this.subscribeObserver();
  },
  beforeDestroy: function beforeDestroy() {
    this.unsubscribeObserver();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getResources: function getResources() {
      var _this = this;
      this.isBusy = true;
      this.setShowLoading(true);
      var params = {
        email: this.userEmail
      };
      WorkEnvironmentsService.getResources(params).then(function (response) {
        _this.items = response.data;
        _this.isBusy = false;
        _this.setShowLoading(false);
      });
    },
    toggleInstance: function toggleInstance(instance) {
      WorkEnvironmentsService.toggleResource(instance).then(function (response) {
        console.log(response);
      });
    },
    getInitialConfig: function getInitialConfig() {
      var _this2 = this;
      WorkEnvironmentsService.getConfig().then(function (response) {
        _this2.config = response.data;
        _this2.business_cases = _this2.config.projects;
      });
    },
    getFirestoreCollection: function getFirestoreCollection() {
      var email = this.userEmail;
      var db = firebaseDataOperation.firestore();
      var ref = db.collectionGroup('machines');
      return ref.where('user_email', '==', email);
    },
    subscribeObserver: function subscribeObserver() {
      var _this3 = this;
      this.getResources();
      var docRef = this.getFirestoreCollection();
      docRef.onSnapshot(function (querySnapshot) {
        querySnapshot.docChanges().forEach(function (change) {
          if (change.type === 'modified') {
            _this3.updateList(change, change.type);
          }
        });
      });
      console.log('Subscribe Observer');
    },
    unsubscribeObserver: function unsubscribeObserver() {
      var docRef = this.getFirestoreCollection();
      docRef.onSnapshot(function () {});
      console.log('Unsubscribe observer');
    },
    updateList: function updateList(change, type) {
      var foundIndex = this.items.findIndex(function (e) {
        return e.doc_id === change.doc.id;
      });
      var index = foundIndex === -1 && type === 'added' ? 0 : foundIndex;
      var edit_data = change.doc.data();
      edit_data.doc_id = change.doc.id;
      this.$set(this.items, index, edit_data);
      console.log("".concat(type, " document"));
    },
    viewMonitoring: function viewMonitoring(item) {
      var _this4 = this;
      this.item = item;
      var params = {
        pr_name: item.pr_name,
        instance_id: item.instance_name
      };
      WorkEnvironmentsService.monitoringGraphics(params).then(function (response) {
        console.log(response);
        _this4.loaded = false;
        var datapoints_monitoring_cpu = response.data.cpu;
        var datapoints_monitoring_ram = response.data.ram;
        _this4.cpuData.labels = datapoints_monitoring_cpu.axis_x;
        _this4.cpuData.datasets[0].data = datapoints_monitoring_cpu.axis_y;
        _this4.cpuData.datasets[1].data = datapoints_monitoring_ram.axis_y;
        _this4.loaded = true;
      });
      this.$refs[this.MODAL_MONITORING_RESOURCE].onOpen();
    },
    onOpenRequestUpdate: function onOpenRequestUpdate(item) {
      item.email = item.user_email;
      item.mt = item.notebook_machine_config.machineType;
      this.itemToUpdate = item;
      this.$refs[this.MODAL_REQUEST_UPDATE].onOpen();
    }
  }),
  computed: {
    headers: function headers() {
      return [{
        text: this.translate('table_my_work_envs.notebook'),
        value: 'instance_name'
      }, {
        text: this.translate('table_my_work_envs.project_gcp'),
        value: 'pr_name'
      }, {
        text: this.translate('table_my_work_envs.link'),
        value: 'notebook_url'
      }, {
        text: this.translate('table_my_work_envs.status'),
        value: 'status'
      }, {
        text: this.translate('table_my_work_envs.actions'),
        value: 'actions'
      }];
    },
    instanceUrl: function instanceUrl() {
      return function (instance) {
        return "https://".concat(instance.notebook_url);
      };
    },
    statusColor: function statusColor() {
      return function (instance) {
        var status = instance.status;
        return status === 'ACTIVE' ? 'green' : status === 'STOPPED' ? 'red' : 'info';
      };
    }
  }
};